import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0add2be4")

_pushScopeId("data-v-0add2be4")
const _hoisted_1 = {
  class: "remarks_main",
  id: "RemarksInfo"
}
const _hoisted_2 = { class: "remarks_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "remarks_title" }, "Remarks", -1)
const _hoisted_4 = { class: "remarks_cnt" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getData("remarkContent")), 1)
    ])
  ]))
})